import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SendPayRoleComponent from './SendPayRoleComponent';
import { feathersCreateData } from '../../services';
import { Grid } from '@material-ui/core';

const SendPayRoleContainer = ({ handleLogOut, setLoading, handleOpenSnack }) => {
  // const user = useSelector((state) => state.user);
  const [accountList, setAccountList] = useState([]);

  const getAccounts = async () => {
    try {
      const getAccountsData = await feathersCreateData('core-server', {
        service: 'ACCOUNT',
        func: 'RETURN CONSOLIDATED ACCOUNTS',
        data: { },
      })();
      // console.log(getAccountsData);

      if (
        getAccountsData.error === undefined ||
        getAccountsData.error !== false
      ) {
        //show message error
        return;
      }

      setAccountList(getAccountsData.data || []);
    } catch (e) {
      // console.log(e);
    }
  };
  SendPayRoleContainer.propTypes = {
    handleLogOut: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
  };

  useEffect(() => {
    getAccounts();
    // eslint-disable-next-line
  }, []);

  if (accountList.length > 0) {
    return (
      <SendPayRoleComponent
        accountList={accountList}
        handleLogOut={handleLogOut}
        handleOpenSnack={handleOpenSnack}
      />
    );

  } else {
    return <Grid>Cargando</Grid>
  }
};
SendPayRoleContainer.propTypes = {
  handleLogOut: PropTypes.func.isRequired,
};
export default SendPayRoleContainer;
